import script from "./material.vue?vue&type=script&lang=ts&setup=true"
export * from "./material.vue?vue&type=script&lang=ts&setup=true"

import "./material.vue?vue&type=style&index=0&id=7bbf3d50&lang=scss"

const __exports__ = script;

export default __exports__